import { render, staticRenderFns } from "./demo-selector.vue?vue&type=template&id=448860fe&scoped=true&"
import script from "./demo-selector.vue?vue&type=script&lang=js&"
export * from "./demo-selector.vue?vue&type=script&lang=js&"
import style0 from "./demo-selector.vue?vue&type=style&index=0&id=448860fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448860fe",
  null
  
)

export default component.exports